import { http } from '../../http';

export default {
  getHistoricalMaps() {
    return http.get('/history-maps');
  },

  getHistoricalMapsBySlug(slug) {
    return http.get(`/history-maps/${slug}`);
  },

  getHistoricalDownloadMaps(slug) {
    return http.get(`/history-maps/download/${slug}`);
  },
};
